//packages blocks
import moment from "moment";
import Lottie from "lottie-react";
import { useHistory } from "react-router";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useReducer, useState } from "react";
import {
  Typography,
  CircularProgress,
  Table,
  TableCell,
  TableContainer,
  TableRow,
  TableBody,
  TableHead,
  Box,
} from "@material-ui/core";
//common blocks
import { SearchInput } from "../../../components/form/searchInput";
//styles, utils, assets and api blocks
import { BLACK } from "../../../theme";
import { amountFormat } from "../../../util/constants";
import { setAlert } from "../../../redux/reducers/alert";
import {
  getAllTransactions,
  searchTransactions,
} from "../../../api/transactions";
import noDataFoundAnimation from "../../../assets/video/no-data-found-animation.json";
import { capitalizeFirstLetter } from "../../../util/Date";
import { getAllSchools } from "../../../api/schools";

export const TransactionsTable = () => {
  const { t } = useTranslation();
  const [page, setPage] = useState(0);
  const [totalCount, setTotalCount] = useState(null);
  const [transactions, setTransactions] = useState([]);
  const { schoolId, role, token, id } = useSelector((state) => state.user);
  const [loading, setLoading] = useState(false);
  const [SearchValue, setSearchValue] = useState("");
  const [{ search, searchError }, setData] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    {
      search: "",
      searchError: false,
    }
  );
  const [payeeType, setPayeeType] = useState("STUDENT");
  const tablePayeeType = capitalizeFirstLetter(payeeType?.toLowerCase());
  const payeeTypeForManagers =
    role === "superadmin" ? "" : `(${tablePayeeType})`;

  const handleSearching = (props) => (event) => {
    setPage(0);
    setTotalCount(0);
    setSearchValue(event.target.value);
    setData({
      search: event.target.value,
      searchError: false,
    });
  };
  const dispatch = useDispatch();
  const showErrorAlert = (message) => {
    dispatch(
      setAlert({
        severity: "error",
        message,
        show: true,
      })
    );
  };
  const fetchTransactions = async () => {
    try {
      setLoading(true);
      const payload = {
        schoolId,
        role,
      };
      const response = await getAllTransactions(payload, page, token, 5);
      if (response.status) {
        setTransactions(response?.students.rows);
        setTotalCount(response?.students.count);
      } else {
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (SearchValue === "") {
      fetchTransactions();
    } else {
      (async () => {
        setLoading(true);
        try {
          setTransactions([]);
          const payload = {
            schoolId,
            role,
          };
          const response = await searchTransactions(
            payload,
            SearchValue,
            token
          );
          if (response.status) {
            setTotalCount(response?.students.count);
            setTransactions(response?.students.rows);
            if (
              response.students.count === 0 ||
              response.students.rows === []
            ) {
              showErrorAlert(t("text_records_not_found"));
            }
          }
          setLoading(false);
        } catch (e) {
          showErrorAlert(
            e.message || t("text_error_in_searching_transactions")
          );
          setLoading(false);
        }
      })();
    }
  }, [SearchValue]);

  const history = useHistory();
  const onGetId = (id) => {
    history.push({
      pathname: `/transactions/${id}`,
      state: {
        transaction: transactions,
      },
    });
  };

  const fetchSchools = async () => {
    try {
      const payload = {
        role,
        id,
        schoolId,
      };
      const response = await getAllSchools(payload, token);

      if (response?.status) {
        setPayeeType(response?.schools[0].payeeType);
      }
    } catch (e) {}
  };

  useEffect(() => {
    fetchSchools();
  }, []);

  return (
    <div className="transactions-card">
      <div className="transaction-head">
        <Typography variant="h4" style={{ color: BLACK, marginLeft:"3.25vw" }}>
          {t("text_recent_transactions")}
        </Typography>
        <div className="recent-transaction-searchbox">
          <SearchInput
            placeholder="Search transactions"
            disabled={role === "readOnly" ? true : false}
            hideLabel={true}
            error={searchError}
            value={search}
            onChange={handleSearching}
            label={t("text_search_by_order_or_payee")}
            name="search"
            height={35}
          />
        </div>
      </div>
      <div
        style={{
          maxHeight: 400,
          overflowY: "auto",
        }}
      >
        {loading ? (
          <div
            style={{
              height: "400px",
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <CircularProgress size={20} style={{ color: "black" }} />
            {t("text_fetching_transactions")}
          </div>
        ) : (
          <TableContainer
            style={{
              marginTop: 5,
              borderRadius: 20,
              boxShadow: "0 0 10px rgb(0 0 0 / 10%)",
            }}
          >
            <Table>
              <TableHead>
                <TableRow style={{ backgroundColor: "#3F6B7A", height:74 }}>
                  <TableCell
                    align="center"
                    style={{ color: "white", fontWeight: "bold" }}
                  >
                    {`${t("text_payee_id")} ${payeeTypeForManagers}`}
                  </TableCell>
                  <TableCell
                    align="center"
                    style={{ color: "white", fontWeight: "bold" }}
                  >
                    {t("text_date")}
                  </TableCell>
                  <TableCell
                    align="center"
                    style={{ color: "white", fontWeight: "bold" }}
                  >
                    {t("text_amount")}
                  </TableCell>

                  <TableCell
                    align="center"
                    style={{ color: "white", fontWeight: "bold" }}
                  >
                    {t("text_order_id")}
                  </TableCell>
                  <TableCell
                    align="center"
                    style={{ color: "white", fontWeight: "bold" }}
                  ></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {transactions
                  ? transactions.map((e, i) => (
                      <>
                        {e.amount !== 0 ? (
                          <TableRow key={e.id}>
                            <TableCell
                              align="center"
                              style={{
                                fontWeight: "500",
                              }}
                            >
                              {e?.payeeType === "STUDENT" ? e.studentRegNo : e.parentRegNo}
                            </TableCell>
                            <TableCell
                              align="center"
                              style={{
                                fontWeight: "500",
                              }}
                            >
                              {e?.gstPaidDate ?? "N/A"}
                            </TableCell>
                            <TableCell
                              align="center"
                              style={{
                                fontWeight: "500",
                              }}
                            >
                              {amountFormat(e.amount)}
                            </TableCell>
                            <TableCell
                              align="center"
                              style={{
                                fontWeight: "500",
                              }}
                            >
                              {e?.bankOrderID ?? "N/A"}
                            </TableCell>
                            <TableCell align="center">
                              <i
                                className="fas fa-arrow-right"
                                style={{
                                  color: "white",
                                  background: "#04acdd",
                                  padding: 6,
                                  borderRadius: "50%",
                                  cursor: "pointer",
                                }}
                                onClick={() => onGetId(e.id)}
                              ></i>
                            </TableCell>
                          </TableRow>
                        ) : (
                          <></>
                        )}
                      </>
                    ))
                  : ""}
              </TableBody>
            </Table>
          </TableContainer>
        )}

        {transactions?.length === 0 && (
          <Box display="flex" justifyContent="center">
            <Lottie animationData={noDataFoundAnimation} loop={true} />
          </Box>
        )}
      </div>
    </div>
  );
};
